import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BranchCameraWithCameras } from '../../../../types';
import { RouterModule } from '@angular/router';

type CellParams = ICellRendererParams & { deleteCallback: (element: BranchCameraWithCameras) => void };

@Component({
  selector: 'app-pan-cell-installer-dashboard-camera-provider-actions',
  imports: [UiModule, MatTooltipModule, RouterModule],
  templateUrl: './cell-installer-dashboard-camera-provider-actions.component.html',
  styleUrl: './cell-installer-dashboard-camera-provider-actions.component.scss',
})
export class CellInstallerDashboardCameraProviderActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
